const redirectPath = '/profile/necessary_items/edit';

// 必須項目の入力が未入力の場合に入力ページにリダイレクトします。
export default defineNuxtRouteMiddleware(() => {
  const { state } = useUser();

  if (state.value.profile) {
    const profile = state.value.profile;

    // MEMO
    // 利用規約同意フラグのリリースは2025-06-05です。
    // その日時以前は利用規約同意フラグはtrueと扱います。
    const agreedWithTerms = profile.agreedWithTerms || new Date(profile.createdAt) < new Date('2025-06-05');

    // 氏名・生年月日・利用規約同意フラグが未入力の場合にリダイレクトします。
    const isNotSaved =
      profile.lastName === '' ||
      profile.firstName === '' ||
      profile.yearOfBirth === null ||
      profile.monthOfBirth === null ||
      profile.dayOfBirth === null ||
      !agreedWithTerms;

    if (isNotSaved) {
      return navigateTo(redirectPath);
    }
  }
});
